import { createSlice } from '@reduxjs/toolkit';
import { addMultipleHomeOwners} from '../HomeownerApi';

const addMultipleHomeOwnersSlice = createSlice({
  name: 'addMultipleHomeOwners',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(addMultipleHomeOwners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMultipleHomeOwners.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addMultipleHomeOwners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default addMultipleHomeOwnersSlice.reducer;
